export function taxOff(org, rate, how) {
  if( org == '') { return NaN }
  if (typeof parseInt(org) !== "number") { return NaN}
  // if (typeof org !== "number") { return NaN; }
  if (typeof rate !== "number") { return NaN }
  if( org <= 0) { return 0 }
  let taxrate = rate < 0 ? 0 : rate
  let val = org / (1+taxrate)
  let rtnval = 0
  if( how == "ROUND_UP") {
    rtnval =  Math.ceil(val)
  } else if( how == "ROUND_DOWN") {
    rtnval = Math.floor(val)
  } else {
    rtnval =  Math.round(val)
  }
  return rtnval
}
export function taxOffDec(org, rate, how) {
  if( org == '') { return NaN }
  if (typeof parseInt(org) !== "number") { return NaN}
  // if (typeof org !== "number") { return NaN; }
  if (typeof rate !== "number") { return NaN }
  if( org <= 0) { return 0 }
  let taxrate = rate < 0 ? 0 : rate
  let val = org / (1+taxrate)
  let rtnval = 0
  if( how == "ROUND_UP") {
    rtnval =  Math.ceil(val * 100) / 100 //tofixed
  } else if( how == "ROUND_DOWN") {
    rtnval = Math.floor(val * 100) / 100 //
  } else {
    rtnval =  Math.round(val * 100) / 100
  }
  return rtnval
}
export function taxAddDec(org, rate, how) {
  if( org == '') { return NaN }
  if (typeof parseInt(org) !== "number") { return NaN}
  if (typeof rate !== "number") { return NaN }
  if( org <= 0) { return 0 }
  let taxrate = rate < 0 ? 0 : rate
  let val = org * (1+taxrate)
  let rtnval = 0
  if( how == "ROUND_UP") {
    rtnval =  Math.ceil(val * 100) / 100
  } else if( how == "ROUND_DOWN") {
    rtnval = Math.floor(val * 100) / 100
  } else {
    rtnval =  Math.round(val * 100) / 100
  }
  return rtnval
}
export function taxAdd(org, rate, how) {
  if( org == '') { return NaN }
  if (typeof parseInt(org) !== "number") { return NaN}
  if (typeof rate !== "number") { return NaN }
  if( org <= 0) { return 0 }
  let taxrate = rate < 0 ? 0 : rate
  let val = org * (1+taxrate)
  let rtnval = 0
  if( how == "ROUND_UP") {
    rtnval =  Math.ceil(val)
  } else if( how == "ROUND_DOWN") {
    rtnval = Math.floor(val)
  } else {
    rtnval =  Math.round(val)
  }
  return rtnval
}

export function getFormatNum(org, how, isForRate = false) {
  if (org === "" || typeof parseInt(org) !== "number") {
    return '/'
  }
  let rtnval = 0
  const num = isForRate ? 10000 : 100
  switch(how) {
    case "ROUND_UP":
    rtnval = Math.ceil(org * num) / num
    break
    case "ROUND_DOWN":
    rtnval = Math.floor(org * num) / num
    break
    default:
    rtnval =  Math.round(org * num) / num
  }
  return rtnval
}